export default __webpack_public_path__ + "static/media/play.a939e51f.svg";